import type { Breadcrumb, SetBreadcrumbArgs } from '@/types/breadcrumb'

export const setBreadcrumb = (args: SetBreadcrumbArgs): Breadcrumb => ({
  text: args.text.replace(args.paramName, args.name ? args.name : ''),
  to: args.to.replace(args.paramId, args.id ? args.id : '')
})
